<div role="dialog" class="c-modal u-no-p" [ngClass]="{'u-no-scroll': vm.noScroll}">
    <div class="o-grid o-grid--column c-modal__dialog c-modal__dialog--media u-no-p u-no-m" [ngClass]="{'u-no-transition': vm.dragging}" [ngStyle]="vm.initialized && { 'transform': 'translate(' + vm.coordinates.x + 'px, ' + vm.coordinates.y + 'px)' }">
        <div class="c-modal__header o-grid__cell o-grid__cell--w-fixed u-no-p">
            <div class="o-grid">
                <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed o-grid__cell--o1@md-and-up u-no-pr">
                    <a href="{{vm.media.fileUrl}}" target="_self" class="c-button c-button--icon c-button--tp">
                        <i class="o-icon o-icon--download u-no-mr c-text c-text--s4" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Common.Download' | translate }}</span>
                    </a>
                </div>
                <div class="o-grid__cell o-grid__cell--slim u-no-p"></div>
                <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed o-grid__cell--o1@md-and-up u-no-pl">
                    <button class="c-button c-button--icon c-button--tp" (click)="vm.handleModalClose()">
                        <i class="o-icon o-icon--x u-no-mr c-text c-text--s4" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="c-modal__content u-no-p o-grid__cell o-grid__cell--w-fixed" style="margin:auto">
            <img *ngIf="vm.media.postType==='PICTURE'" src="{{ vm.media.fileUrl }}" alt="{{ vm.media.name }}" class="c-modal__media" [ngStyle]="{ maxWidth: vm.canvas?.width, maxHeight: vm.canvas?.height }">
			<div *ngIf="vm.media.postType === 'VIDEO' && vm.initialized">
				<div [ngStyle]="{ 'max-height': vm.video.maxHeight + 'px', 'max-width': vm.video.maxWidth + 'px' }">
					<vg-player>
						<video #media
								[vgMedia]="media"
								[vgLoop]="true"
								id="singleVideo"
								preload="auto">
							<source [src]="vm.video.sources[0].src" type="video/mp4">
						</video>
						<vg-controls>
							<vg-play-pause></vg-play-pause>
							<vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>
							<vg-scrub-bar>
								<vg-scrub-bar-current-time></vg-scrub-bar-current-time>
							</vg-scrub-bar>
							<vg-time-display vgProperty="left" vgFormat="mm:ss"></vg-time-display>
							<vg-volume>
								<vg-mute></vg-mute>
								<vg-volume-bar></vg-volume-bar>
							</vg-volume>
							<vg-fullscreen></vg-fullscreen>
						</vg-controls>
						<vg-overlay-play></vg-overlay-play>
						<vg-buffering></vg-buffering>
					</vg-player>
				</div>
			</div>
        </div>
    </div>
</div>
